export default __webpack_public_path__ + "static/media/icon.bandage.343264bc.svg";